import { Button, Divider, Modal, Text } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface ExportConfirmationModalProps {
  opened: boolean;
  onClose: () => void;
  onExportCurrentPage: () => Promise<void>;
  onExportAll: () => Promise<void>;
  currentPageCount: number;
  totalCount: number;
}

const ExportConfirmationModal = ({
  opened,
  onClose,
  onExportCurrentPage,
  onExportAll,
  currentPageCount,
  totalCount,
}: ExportConfirmationModalProps) => {
  const { t } = useTranslation();
  const [exportingType, setExportingType] = useState<"current" | "all" | null>(null);

  const handleExportCurrentPage = async () => {
    setExportingType("current");
    await onExportCurrentPage();
    setExportingType(null);
    onClose();
  };

  const handleExportAll = async () => {
    setExportingType("all");
    await onExportAll();
    setExportingType(null);
    onClose();
  };
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("exportModal.title")}
      centered
      size={"md"}
    >
      <div className="flex flex-col gap-4">
        {/* Current Page Section */}
        <div className="flex-1 flex flex-col">
          <Text size="sm" fw={600}>
            {t("exportModal.currentPage")}
          </Text>
          <div className="mt-1 flex flex-col gap-1">
            <Text size="sm" c="dimmed">
              {t("exportModal.currentPageDescription", { count: currentPageCount })}
            </Text>
            <Text size="sm" c="dimmed">
              {t("exportModal.quickExport")}
            </Text>
          </div>
          <div>
            <Button
            leftSection={<IconDownload size={16} />}
            variant="outline"
            color="black"
            onClick={handleExportCurrentPage}
            loading={exportingType === "current"}
            disabled={exportingType !== null}
            className="mt-6"
          >
            {t("common.export")}
          </Button>
          </div>
        </div>

        <Divider orientation="horizontal" />

        {/* All Records Section */}
        <div className="flex-1 flex flex-col">
          <Text size="sm" fw={600}>
            {t("exportModal.allRecords")}
          </Text>
          <div className="mt-1 flex flex-col gap-1">
            <Text size="sm" c="dimmed">
              {t("exportModal.allRecordsDescription", { count: totalCount })}
            </Text>
            <Text size="sm" c="dimmed">
              {t("exportModal.fullExport")}
            </Text>
          </div>
          <div>
            <Button
            leftSection={<IconDownload size={16} />}
            variant="filled"
            color="black"
            onClick={handleExportAll}
            loading={exportingType === "all"}
            disabled={exportingType !== null}
            className="mt-6"
          >
            {t("common.export")}
          </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ExportConfirmationModal;
